import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'IntegrationManager', controller: 'Connection') => ({
	Get: new PostMethod<string, any>({ service, controller, method: 'Get' }),
	Create: new PostMethod<string, any>({ service, controller, method: 'Create' }),
	Update: new PostMethod<string, any>({ service, controller, method: 'Update' }),
	Delete: new PostMethod<boolean, any>({ service, controller, method: 'Delete' }),
	Compile: new PostMethod<boolean, any>({ service, controller, method: 'Compile' }),
	GetMetaData: new PostMethod<string, any>({ service, controller, method: 'GetMetaData' }),
	GetDataBases: new PostMethod<string, any>({ service, controller, method: 'GetDataBases' }),
	GetStoredProcedures: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetStoredProcedures'
	}),
	GetParametersOfStoredProcedure: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetParametersOfStoredProcedure'
	}),
	GetReturnTablesOfStoredProcedure: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetReturnTablesOfStoredProcedure'
	}),
	GetClasses: new PostMethod<Array<string>, any>({
		service,
		controller,
		method: 'GetClasses'
	}),
	GetMethodsOfClass: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetMethodsOfClass'
	}),
	GetReturnTablesOfMethod: new PostMethod<Array<any>, any>({
		service,
		controller,
		method: 'GetReturnTablesOfMethod'
	})
});

export { getMethods };
